import React from 'react';
import Modal from '../common/Modal/Modal';
import styles from './ModalContent.module.css';

/**
 * Modal de contenido (alertas/confirmaciones) que usa el patrón de diseño
 * del Modal común (Companies, Clients, Lockers). Mantiene la API legacy
 * title/body/footer/isOpenModal/onHide para compatibilidad.
 */
const ModalContent = ({ title, body, footer, isOpenModal, onHide }) => {
  return (
    <Modal
      isOpen={isOpenModal}
      onClose={onHide}
      title={title}
      size="md"
      showCloseButton={true}
      closeOnBackdropClick={true}
    >
      <div className={styles.wrapper}>
        {body && <div className={styles.body}>{body}</div>}
        {footer != null && (
          <div className={styles.footer}>{footer}</div>
        )}
      </div>
    </Modal>
  );
};

export default ModalContent;
